// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".offer-table-container .scrollable.table-wrapper{overflow-x:scroll}.offer-table-container .limit-width-text{max-width:20ch;overflow:hidden;text-overflow:ellipsis}.offer-table-container .offer-title{line-height:2rem;font-size:1.2rem}.offer-table-container .pagination-list{margin:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
